var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error"}},[_c('div',{staticClass:"clear_a"},[_c('img',{attrs:{"src":_vm.errorIcon}}),_c('p',[_vm._v("暂未开放该功能!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }